import { render, staticRenderFns } from "./RoomSetting.vue?vue&type=template&id=dee9e24e&scoped=true"
import script from "./RoomSetting.vue?vue&type=script&lang=js"
export * from "./RoomSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee9e24e",
  null
  
)

export default component.exports